import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

import CompactLayout from 'src/layouts/compact';
// OfflinePage must be eagerly loaded (not lazy) because it needs to work when offline
// If lazy-loaded, the browser can't fetch the chunk when the user is offline
import OfflinePage from 'src/pages/OfflinePage';
// PermissionRequestPage must be eagerly loaded because it needs to work before the app loads
// and may be shown before other lazy-loaded components are available
import PermissionRequestPage from 'src/pages/system/PermissionRequestPage';

// ----------------------------------------------------------------------

const Page404 = lazy(() => import('src/pages/404'));
const UpdateVersionPage = lazy(() => import('src/pages/UpdateVersionPage'));
const ContactSupportPage = lazy(() => import('src/pages/ContactSupport'));

// ----------------------------------------------------------------------

export const systemRoutes = [
  {
    path: 'system',
    element: (
      <CompactLayout>
        <Outlet />
      </CompactLayout>
    ),
    children: [
      {
        path: 'update-version',
        element: <UpdateVersionPage />,
      },
      {
        path: 'contact-support',
        element: <ContactSupportPage />,
      },
      {
        path: 'offline',
        element: <OfflinePage />,
      },
      {
        path: 'permissions',
        element: <PermissionRequestPage />,
      },
    ],
  },
];
